/**
 * 한국어 문자열 사전. 이 파일이 문자열 키의 기준(canonical)이며,
 * `en.ts`는 동일한 키를 모두 구현해야 컴파일된다.
 */
export const koMessages = {
  // 공통
  "common.confirm": "확인",
  "common.cancel": "취소",
  "common.cancelAction": "취소하기",
  "common.submitAction": "제출하기",
  "common.save": "저장",
  "common.saving": "저장 중",
  "common.savingEllipsis": "저장 중...",
  "common.saveAction": "저장하기",
  "common.register": "등록",
  "common.registering": "등록 중",
  "common.delete": "삭제",
  "common.deleting": "삭제 중",
  "common.edit": "수정",
  "common.editing": "수정 중",
  "common.editInfo": "정보 수정",
  "common.close": "닫기",
  "common.next": "다음",
  "common.previous": "이전",
  "common.agree": "동의",
  "common.send": "전송",
  "common.sending": "전송 중",
  "common.select": "선택",
  "common.selectDate": "날짜 선택",
  "common.all": "전체",
  "common.processing": "처리 중",
  "common.processingEllipsis": "처리 중...",
  "common.checking": "확인 중...",
  "common.loading": "불러오는 중",
  "common.loadingSentence": "불러오는 중입니다.",
  "common.noData": "데이터가 없습니다",
  "common.noDataToShow": "표시할 데이터가 없습니다.",
  "common.noSearchResult": "검색 결과가 없습니다.",
  "common.activate": "활성화",
  "common.deactivate": "비활성화",
  "common.refresh": "새로고침",
  "common.backToLogin": "로그인으로 돌아가기",
  "common.notProvidedShort": "-",
  "common.duration.seconds": "{seconds}초",
  "common.duration.minutes": "{minutes}분",
  "common.duration.minutesSeconds": "{minutes}분 {seconds}초",
  "common.duration.hours": "{hours}시간",
  "common.duration.hoursMinutes": "{hours}시간 {minutes}분",
  "common.duration.hoursMinutesSeconds": "{hours}시간 {minutes}분 {seconds}초",
  "common.complianceAria": "순응도 {rate}%",
  "common.count.people": "{count}명",
  "common.count.cases": "{count}건",
  "common.round": "{round}회차",
  "common.score": "{score}점",

  // 페이지네이션
  "pagination.first": "첫 페이지",
  "pagination.previous": "이전 페이지",
  "pagination.next": "다음 페이지",
  "pagination.last": "마지막 페이지",

  // 좌측 내비게이션
  "nav.dashboard": "대시보드",
  "nav.patientList": "환자 목록",
  "nav.doctorList": "의료진 목록",
  "nav.hospitalList": "병원 목록",
  "nav.log": "로그",
  "nav.patientNotification": "환자 알림 전송",
  "nav.goToDashboard": "대시보드로 이동",
  "nav.goToHome": "홈으로 이동",

  // 사용자(계정) 메뉴
  "account.privacy": "개인정보 보호",
  "account.terms": "이용약관",
  "account.changePassword": "비밀번호 변경",
  "account.logout": "로그아웃",
  "account.menu": "사용자 메뉴",

  // 언어 설정
  "language.title": "언어 설정",
  "language.menuLabel": "언어",
  "language.selectLanguage": "언어 선택",
  "language.currentSuffix": "(현재 언어)",

  // 로그인
  "login.title": "로그인",
  "login.description": "이메일 주소(ID)를 입력하고 로그인하세요.",
  "login.descriptionApproved": "승인된 사용자만 사용 가능합니다.",
  "login.email": "이메일",
  "login.emailPlaceholder": "이메일(ID)을 입력하세요",
  "login.password": "비밀번호",
  "login.passwordPlaceholder": "비밀번호를 입력하세요",
  "login.rememberEmail": "이메일 주소(ID) 기억하기",
  "login.submitting": "로그인 중...",
  "login.forgotPassword": "비밀번호를 잊으셨나요?",
  "login.findPassword": "비밀번호 찾기",
  "login.mockAccount": "mock 계정",
  "login.mockAccountSelect": "mock 계정 선택",
  "login.mockAccountPlaceholder": "계정 선택",
  "login.error.invalidCredentials": "아이디 또는 비밀번호가 일치하지 않습니다.",
  "login.error.invalidCredentialsWithDetail":
    "아이디 또는 비밀번호가 일치하지 않습니다.\n{message}",
  "login.error.tooManyAttempts": "로그인 시도가 제한되었습니다. 잠시 후 다시 시도해주세요.",
  "login.error.tooManyAttemptsWithDetail": "로그인 시도가 제한되었습니다.\n{message}",
  "login.error.deactivated": "비활성화된 계정입니다. 관리자에게 문의해주세요.",
  "login.error.failed": "로그인에 실패했습니다. 다시 시도해주세요.",
  "login.error.webRoleNotAllowed": "SAT-014 웹은 의료진과 관리자만 사용할 수 있습니다.",
  "login.browser.title": "다른 브라우저 사용을 권장합니다",
  "login.browser.description":
    "현재 브라우저에서는 일부 기능이 제한될 수 있습니다. 크롬(Chrome) 또는 엣지(Edge) 브라우저 사용을 권장합니다.",

  // 비밀번호 찾기 / 재설정 / 초기 설정 / 변경
  "findPassword.title": "비밀번호 찾기",
  "findPassword.description": "등록된 이메일(ID)을 입력하면 비밀번호 재설정 링크를 이메일로 발송합니다.",
  "findPassword.emailLabel": "이메일(ID)",
  "findPassword.emailPlaceholder": "이메일(ID)을 입력하세요",
  "findPassword.submit": "재설정 링크 발송",
  "findPassword.submitting": "발송 중",
  "findPassword.error.emailRequired": "이메일(ID)을 입력해주세요.",
  "findPassword.error.emailFormat": "올바른 이메일 형식을 입력해주세요.",
  "findPassword.error.requestFailed": "비밀번호 재설정 링크 발송 중 오류가 발생했습니다.",
  "findPassword.complete.title": "메일 전송을 완료했습니다",
  "findPassword.complete.sentTo": "비밀번호 재설정 이메일을 {email} 로 발송했습니다.",
  "findPassword.complete.helper": "이메일의 링크를 통해 새 비밀번호를 설정해주세요.",
  "findPassword.complete.spamHelper": "메일이 보이지 않으면 스팸함 또는 프로모션함을 확인해주세요.",

  "resetPassword.title": "비밀번호 재설정",
  "resetPassword.description": "새 비밀번호를 입력해주세요.",
  "resetPassword.newPassword": "새 비밀번호",
  "resetPassword.newPasswordPlaceholder": "8~20자 영문, 숫자, 특수문자",
  "resetPassword.confirmPassword": "새 비밀번호 확인",
  "resetPassword.confirmPasswordPlaceholder": "새 비밀번호를 다시 입력하세요",
  "resetPassword.submit": "비밀번호 변경",
  "resetPassword.submitting": "변경 중",
  "resetPassword.completeTitle": "비밀번호 변경 완료",
  "resetPassword.completeChanged": "비밀번호가 변경되었습니다.",
  "resetPassword.completeRelogin": "보안을 위해 다시 로그인해주세요.",
  "resetPassword.error.linkInvalid": "비밀번호 재설정 링크가 만료되었거나 올바르지 않습니다.",
  "resetPassword.error.tokenMissing": "비밀번호 재설정 토큰이 없습니다.",
  "resetPassword.error.tokenMissingHelp":
    "비밀번호 재설정 토큰이 없습니다. 이메일의 재설정 링크로 다시 접속해주세요.",
  "resetPassword.error.changeFailed": "비밀번호 변경 중 오류가 발생했습니다.",

  "initPassword.title": "의료진 비밀번호 설정",
  "initPassword.description": "계정 사용을 위해 새 비밀번호를 설정해주세요.",
  "initPassword.submit": "비밀번호 설정",
  "initPassword.submitting": "설정 중",
  "initPassword.completeTitle": "비밀번호 설정 완료",
  "initPassword.completeSet": "비밀번호가 설정되었습니다.",
  "initPassword.completeLogin": "보안을 위해 로그인해주세요.",
  "initPassword.error.linkInvalid": "비밀번호 설정 링크가 만료되었거나 올바르지 않습니다.",
  "initPassword.error.tokenMissing": "비밀번호 설정 토큰이 없습니다.",
  "initPassword.error.setFailed": "비밀번호 설정 중 오류가 발생했습니다.",

  "changePassword.title": "비밀번호 재설정",
  "changePassword.description": "보안을 위해 새로운 비밀번호를 설정해주세요.",
  "changePassword.currentPassword": "현재 비밀번호",
  "changePassword.currentPasswordPlaceholder": "현재 비밀번호 입력",
  "changePassword.newPassword": "새 비밀번호",
  "changePassword.newPasswordPlaceholder": "새 비밀번호 입력",
  "changePassword.confirmPassword": "새 비밀번호 확인",
  "changePassword.confirmPasswordPlaceholder": "새 비밀번호 다시 입력",
  "changePassword.submit": "비밀번호 변경",
  "changePassword.submitting": "변경 중",
  "changePassword.success": "비밀번호를 변경했습니다.",

  // 환자 앱 계정 설정 (공개 플로우)
  "accountSetup.checkName.description": "SAT-014의 아이디, 비밀번호\n설정을 위해 본인 확인을 진행해주세요.",
  "accountSetup.checkName.nameLabel": "이름",
  "accountSetup.checkName.namePlaceholder": "이름을 입력하세요",
  "accountSetup.checkName.error.nameRequired": "이름을 입력해주세요.",
  "accountSetup.checkName.error.nameMismatchTitle": "이름 오류",
  "accountSetup.checkName.error.nameMismatch": "입력하신 이름과 일치하지 않습니다.",
  "accountSetup.expiredTitle": "인증정보 만료",
  "accountSetup.expiredNotFound": "인증 정보를 찾을 수 없거나 만료되었습니다.",
  "accountSetup.expiredResend": "인증 URL 재전송을 요청하세요.",
  "accountSetup.requestErrorTitle": "요청 처리 오류",
  "accountSetup.requestError": "요청 처리 중 오류가 발생했습니다.",
  "accountSetup.setup.description": "앱에서 사용할 아이디와 비밀번호를 설정해주세요.",
  "accountSetup.setup.userIdLabel": "아이디",
  "accountSetup.setup.userIdPlaceholder": "6~16자 영문 소문자, 숫자",
  "accountSetup.setup.passwordLabel": "비밀번호",
  "accountSetup.setup.passwordPlaceholder": "8~20자 영문, 숫자, 특수문자",
  "accountSetup.setup.confirmPasswordLabel": "비밀번호 확인",
  "accountSetup.setup.confirmPasswordPlaceholder": "비밀번호를 다시 입력하세요",
  "accountSetup.setup.complete": "계정 설정 완료",
  "accountSetup.setup.error.userIdRequired": "아이디를 입력해주세요.",
  "accountSetup.setup.error.userIdInvalid": "사용할 수 없는 아이디입니다.",
  "accountSetup.setup.error.userIdTaken": "이미 사용 중인 아이디입니다.",
  "accountSetup.setup.error.passwordCondition": "비밀번호 조건을 확인해주세요.",
  "accountSetup.setup.error.passwordMismatch": "비밀번호가 일치하지 않습니다.",
  "accountSetup.setup.error.setupFailed": "계정 설정 중 오류가 발생했습니다.",
  "accountSetup.complete.done": "계정 설정이 완료되었습니다.",
  "accountSetup.complete.loginGuide": "SAT-014 앱에서 새 계정으로 로그인해주세요.",
  "accountSetup.expired.linkExpired": "계정 설정 링크가 만료되었습니다.",
  "accountSetup.expired.beforeSetupPoint": "계정 설정 전",
  "accountSetup.expired.beforeSetupGuide": "이라면, 등록하신 병원에 계정 설정 메세지 재전송을 요청하세요.",
  "accountSetup.expired.afterSetupPoint": "계정 설정을 완료",
  "accountSetup.expired.afterSetupGuide": "하셨다면, SAT-014를 시작하세요.",
  "accountSetup.consent.terms": "서비스 이용약관",
  "accountSetup.consent.privacy": "개인정보 처리방침",

  "nameField.required": "{label}을 입력해주세요.",
  "nameField.minLength": "{label}은 2자리 이상 입력해주세요.",
  "nameField.noNumber": "{label}에는 숫자를 입력할 수 없습니다.",
  "nameField.noSpecialCharacter": "{label}에는 특수문자를 입력할 수 없습니다.",
  "nameField.charset": "{label}은 한글, 영문, 공백만 입력 가능합니다.",

  // 비밀번호 / 아이디 규칙
  "password.rule.length": "8~20자로 입력해주세요.",
  "password.rule.letter": "영문을 포함해주세요.",
  "password.rule.number": "숫자를 포함해주세요.",
  "password.rule.special": "특수문자 !@#$%^&* 중 하나를 포함해주세요.",
  "password.confirm.required": "새 비밀번호를 다시 입력해주세요.",
  "password.confirm.mismatch": "새 비밀번호가 일치하지 않습니다.",
  "password.error.condition": "비밀번호 조건을 확인해주세요.",
  "appId.rule.length": "6~16자로 입력해주세요.",
  "appId.rule.charset": "영문 소문자, 숫자만 사용할 수 있습니다.",

  // 세션 / 공통 오류
  "session.duplicateLogin.title": "중복 로그인",
  "session.duplicateLogin.description": "다른 기기 또는 브라우저에서 로그인되어 현재 세션이 종료되었습니다.",
  "session.expired.title": "로그인 세션 만료",
  "session.expired.description": "로그인 세션이 만료되었습니다.",
  "session.reloginGuide": "다시 로그인해주세요.",
  "error.requestFailed": "요청 처리 중 오류가 발생했습니다.",
  "error.requestEmpty": "요청 정보가 없습니다.",
  "error.boundary.title": "화면을 불러오지 못했습니다.",
  "error.boundary.message": "잠시 후 다시 시도하거나 대시보드로 이동해 주세요.",
  "error.boundary.detail": "에러 상세 정보",
  "notFound.title": "페이지를 찾을 수 없습니다.",
  "notFound.description": "요청한 경로가 존재하지 않습니다.",
  "toast.closeNotification": "알림 닫기",

  // 역할
  "role.admin": "관리자",
  "role.medicalExpert": "의료진",
  "role.nurse": "간호사",
  "role.patient": "환자",
  "role.guardian": "보호자",
  "role.cro": "CRO",
  "role.unknown": "알 수 없음",

  // 성별
  "gender.male": "남성",
  "gender.female": "여성",
  "gender.unspecified": "성별 미지정",
  "gender.notSelected": "선택 안 함",

  // 상태
  "status.inProgress": "진행 중",
  "status.notStarted": "시작 전",
  "status.completed": "완료",
  "status.incomplete": "미완료",
  "status.canceled": "취소",
  "status.stopped": "중단",
  "status.noTreatment": "치료 없음",
  "status.attentionNeeded": "주의 필요",
  "status.active": "활성",
  "status.inactive": "비활성",
  "status.unknown": "알 수 없음",
  "status.treatmentInProgress": "치료 진행 중",
  "status.activityCompleted": "활동 완료(치료 종료)",
  "status.filter.viewAll": "모두 보기",

  // 대시보드
  "dashboard.metric.totalPatients": "전체 환자 수",
  "dashboard.metric.inProgressPatients": "진행중인 환자 수",
  "dashboard.metric.lowCompliance": "순응도 60% 미만",
  "dashboard.comparedToLastMonth": "전월 대비",
  "dashboard.patientList": "환자 리스트",
  "dashboard.viewAll": "전체 보기",
  "dashboard.column.nameWithScreeningId": "이름(스크리닝 ID)",
  "dashboard.column.name": "이름",
  "dashboard.column.screeningId": "스크리닝 ID",
  "dashboard.column.compliance": "순응도",
  "dashboard.column.status": "진행상태",
  "dashboard.column.treatmentRound": "치료 차수",
  "dashboard.tablePagination": "대시보드 테이블 페이지네이션",
  "dashboard.treatmentRoundValue": "{count}차",

  // 환자
  "patient.title": "환자 정보",
  "patient.titleWithScreeningId": "환자 정보 ({screeningId})",
  "patient.treatmentInfoTitle": "환자 치료 정보",
  "patient.noScreeningId": "환자의 스크리닝 ID가 없습니다.",
  "patient.noName": "환자 이름이 없습니다.",
  "patient.select": "환자를 선택하세요",
  "patient.selectDescription": "목록에서 환자를 선택하면 상세 정보가 표시됩니다.",
  "patient.filter": "환자 필터",
  "patient.register": "환자 등록",
  "patient.search": "환자 검색",
  "patient.searchPlaceholder": "환자 이름, 휴대폰 번호, 이메일 검색...",
  "patient.searchByNamePlaceholder": "환자 이름 검색...",
  "patient.searchByName": "환자 이름 검색",
  "patient.clearSearch": "검색어 지우기",
  "patient.empty": "환자가 없습니다.",
  "patient.loadingList": "환자 목록을 가져오고 있습니다.",
  "patient.emptySearchData": "검색어에 해당하는 환자 데이터가 없습니다.",
  "patient.emptyDashboardData": "대시보드에서 불러온 환자 데이터가 없습니다.",
  "patient.backToList": "환자 목록으로 돌아가기",
  "patient.generalInfo": "일반 정보",
  "patient.bodyInfo": "신체 정보",
  "patient.restrictedInfo": "제한 정보",
  "patient.noEmail": "이메일 정보 없음",
  "patient.noPhone": "전화번호 정보 없음",
  "patient.noBirthday": "생년월일 정보 없음",
  "patient.emptyMemo": "메모가 비어 있습니다.",
  "patient.birthdayWithAge": "{date} [만 {age}세]",
  "patient.screeningIdValue": "스크리닝 ID {screeningId}",
  "patient.treatmentCount": "치료 {count}건",
  "patient.resendSetupSms": "계정 설정 SMS 재발송",
  "patient.addTreatment": "치료 추가",
  "patient.treatmentList": "치료 목록",
  "patient.column.status": "상태",
  "patient.column.progress": "진행 상황",
  "patient.column.period": "기간",
  "patient.column.doctor": "담당의",
  "patient.create.title": "새로운 환자 등록",
  "patient.create.subtitle": "환자 정보를 입력하여 새 계정을 생성하세요.",
  "patient.edit.title": "환자 정보 수정",
  "patient.edit.subtitle": "환자 정보를 입력하여 계정 정보를 수정할 수 있습니다.",
  "patient.section.personalInfo": "개인 정보",
  "patient.section.personalInfoSection": "개인 정보 섹션",
  "patient.section.additionalInfo": "추가 정보",
  "patient.section.bodyInfoSection": "신체 정보 섹션",
  "patient.section.etcInfoSection": "기타 정보 섹션",
  "patient.field.name": "이름",
  "patient.field.phone": "전화번호",
  "patient.field.email": "이메일",
  "patient.field.birthday": "생일",
  "patient.field.gender": "성별",
  "patient.field.memo": "메모",
  "patient.field.memoPlaceholder": "특이사항이나 참고사항을 입력하세요",
  "patient.deactivate.title": "환자 계정을 비활성화할까요?",
  "patient.deactivate.description": "진행 중인 치료가 있으면 먼저 종료한 뒤 환자 계정을 비활성화합니다.",
  "patient.toast.feedbackSaved": "피드백을 저장했습니다.",
  "patient.toast.accountCreated": "계정 생성 완료. 해당 메일로 계정 정보가 전달됩니다.",
  "patient.toast.updated": "환자 정보를 수정했습니다.",
  "patient.toast.setupSmsResent": "계정 설정 SMS를 재발송했습니다.",
  "patient.toast.deactivated": "환자 계정을 비활성화했습니다.",
  "patient.toast.activated": "환자 계정을 활성화했습니다.",
  "patient.toast.messageSent": "메시지 전송 완료",
  "patient.toast.activityUuidMissing": "활동 UUID가 없어 상세 정보를 불러올 수 없습니다.",
  "patient.validation.title": "환자 등록 정보를 확인해주세요.",
  "patient.validation.updateTitle": "환자 정보를 확인해주세요.",
  "patient.validation.nameRequired": "이름을 입력해야 합니다.",
  "patient.validation.nameMinLength": "이름은 최소 2자 이상이어야 합니다.",
  "patient.validation.emailFormat": "이메일 형식이 아닙니다",
  "patient.validation.countryRequired": "국가를 선택해주세요.",
  "patient.validation.countryUnsupported": "지원하지 않는 국가입니다.",
  "patient.validation.countryCodeRequired": "국가 코드를 입력해주세요.",
  "patient.validation.timeZoneRequired": "지역을 선택해주세요.",
  "patient.validation.genderRequired": "성별을 선택해주세요.",
  "patient.validation.dateRequired": "날짜를 입력해주세요.",
  "patient.validation.dateLength": "날짜는 8자리 숫자여야 합니다.",
  "patient.validation.dateFormat": "올바른 날짜 형식이 아닙니다 (YYYYMMDD).",
  "patient.validation.dateFormatDash": "생일은 YYYY-MM-DD 형식으로 입력해주세요.",
  "patient.validation.dateInvalid": "유효하지 않은 날짜입니다.",
  "patient.validation.birthdayFuture": "생일은 현재 날짜를 넘을 수 없습니다.",
  "patient.compliance": "순응도: {rate}%",

  // 의료진
  "doctor.select": "의료진을 선택하세요",
  "doctor.selectDescription": "목록에서 계정을 선택하면 상세 정보가 표시됩니다.",
  "doctor.register": "의사 등록",
  "doctor.search": "의사 이름 검색",
  "doctor.empty": "등록된 의료진이 없습니다.",
  "doctor.emptyHelper": "검색어와 필터를 확인하거나 새 계정을 등록해주세요.",
  "doctor.generalInfo": "일반 정보",
  "doctor.patientList": "환자 리스트",
  "doctor.column.screeningId": "스크리닝 ID",
  "doctor.column.treatmentStatus": "치료 상태",
  "doctor.column.accountStatus": "계정상태",
  "doctor.noPatients": "담당 환자가 없습니다.",
  "doctor.noPhone": "전화번호 정보 없음",
  "doctor.noMemo": "메모 정보 없음",
  "doctor.resendPasswordSetup": "비밀번호 설정 메시지 재전송",
  "doctor.toast.passwordSetupResent": "비밀번호 설정 메시지를 재전송했습니다.",
  "doctor.toast.created": "의사 계정을 생성했습니다.",
  "doctor.toast.updated": "의료진 정보를 수정했습니다.",
  "doctor.toast.activated": "의료진 계정을 활성화했습니다.",
  "doctor.toast.deactivated": "의료진 계정을 비활성화했습니다.",
  "doctor.create.title": "의사 등록",
  "doctor.create.subtitle": "의료진 정보를 입력하여 새 계정을 생성하세요.",
  "doctor.edit.title": "의료진 정보 수정",
  "doctor.edit.subtitle": "의료진 계정 정보를 수정할 수 있습니다.",
  "doctor.deactivate.title": "의료진 계정을 비활성화할까요?",
  "doctor.deactivate.description": "비활성화된 의료진 계정은 다시 활성화하기 전까지 사용할 수 없습니다.",
  "doctor.section.basicInfo": "기본 정보",
  "doctor.section.affiliationInfo": "소속 및 기타 정보",
  "doctor.field.name": "이름",
  "doctor.field.namePlaceholder": "의료진 이름을 입력하세요",
  "doctor.field.email": "이메일",
  "doctor.field.hospital": "소속 병원",
  "doctor.field.phone": "전화번호",
  "doctor.field.memo": "메모",
  "doctor.field.memoPlaceholder": "특이사항이나 참고사항을 입력하세요",
  "doctor.nameLabel": "의료진 이름",
  "doctor.validation.title": "의사 등록 정보를 확인해주세요.",
  "doctor.validation.nameRequired": "의료진 이름을 입력해주세요.",
  "doctor.validation.emailRequired": "이메일을 입력해주세요.",
  "doctor.validation.emailFormat": "올바른 이메일 형식을 입력해주세요.",
  "doctor.validation.hospitalRequired": "소속 병원을 입력해주세요.",
  "doctor.usageWithLastLogin": "사용 중 (마지막 로그인 날짜 : {date})",
  "doctor.beforeUsage": "사용 전",

  // 병원
  "hospital.select": "병원을 선택하세요",
  "hospital.selectDescription": "목록에서 병원을 선택하면 상세 정보가 표시됩니다.",
  "hospital.listTitle": "병원 목록",
  "hospital.countSummary": "{count}개 병원",
  "hospital.register": "병원 등록",
  "hospital.searchPlaceholder": "병원명 또는 코드 검색",
  "hospital.doctorCount": "의사 {count}",
  "hospital.patientCount": "환자 {count}",
  "hospital.empty": "등록된 병원이 없습니다.",
  "hospital.emptyHelper": "검색어를 확인하거나 병원을 등록해주세요.",
  "hospital.info": "병원 정보",
  "hospital.field.code": "병원 코드",
  "hospital.registeredDoctorCount": "등록 의사 수",
  "hospital.registeredPatientCount": "등록 환자 수",
  "hospital.delete.title": "병원 삭제",
  "hospital.delete.subtitle": "{name} 병원을 삭제하시겠습니까?",
  "hospital.delete.description": "삭제 후에는 병원 목록에서 해당 병원을 다시 조회할 수 없습니다.",
  "hospital.create.title": "병원 등록",
  "hospital.create.subtitle": "병원 정보를 입력하여 새 병원을 등록하세요.",
  "hospital.field.name": "병원 이름",
  "hospital.field.namePlaceholder": "병원 전체 이름을 입력하세요",
  "hospital.section.basicInfo": "기본 정보",
  "hospital.toast.deleted": "병원을 삭제했습니다.",
  "hospital.toast.deleteBlocked": "등록된 의사와 환자가 없는 병원만 삭제할 수 있습니다.",
  "hospital.toast.created": "병원을 등록했습니다.",
  "hospital.validation.title": "병원 등록 정보를 확인해주세요.",
  "hospital.validation.nameRequired": "병원 전체 이름을 입력해주세요.",
  "hospital.validation.nameMinLength": "병원 전체 이름은 2자리 이상 입력해주세요.",
  "hospital.validation.nameCharset": "병원 이름은 한글, 영문, 공백만 입력 가능합니다.",
  "hospital.validation.codeRequired": "병원 코드를 입력해주세요.",
  "hospital.validation.codeFormat": "병원 코드는 알파벳 3자리로 입력해주세요.",
  "hospital.loadingList": "병원 목록 불러오는 중",
  "hospital.selectPrompt": "병원을 선택하세요",
  "hospital.noneRegistered": "등록된 병원이 없습니다",
  "hospital.createNew": "새 병원 등록하기",
  "hospital.codeValue": "병원 코드 {code}",

  // 치료(처방)
  "treatment.infoTitle": "치료 정보",
  "treatment.notFound": "치료 정보를 찾을 수 없습니다.",
  "treatment.sendEncouragement": "독려 알림 보내기",
  "treatment.stop": "치료 중지",
  "treatment.stopping": "중지 중",
  "treatment.stopConfirmSubtitle": "현재 치료를 중지하시겠습니까?",
  "treatment.stopConfirmDescription": "중지 후에는 치료 상태가 종료 상태로 변경됩니다.",
  "treatment.stopShort": "중지",
  "treatment.compliance": "순응도",
  "treatment.progressRate": "진행률",
  "treatment.performanceRate": "수행률",
  "treatment.summaryAria":
    "순응도 {compliance}, 진행률 {progress}, 수행률 {performance}",
  "treatment.field.number": "치료 번호",
  "treatment.field.currentStatus": "현재 상태",
  "treatment.field.period": "기간",
  "treatment.field.doctor": "치료 담당 의사",
  "treatment.activityLog": "치료 활동 로그",
  "treatment.activityLogFilter": "활동 로그 필터",
  "treatment.activityLogPagination": "치료 활동 로그 페이지 이동",
  "treatment.column.date": "날짜",
  "treatment.column.status": "상태",
  "treatment.column.activityType": "활동 유형",
  "treatment.column.startTime": "시작 시간",
  "treatment.column.endTime": "종료 시간",
  "treatment.filter.regular": "정규 활동 보기",
  "treatment.filter.practice": "연습 활동 보기",
  "treatment.filter.all": "모든 활동 보기",
  "treatment.weekly.empty": "주차별 수행 데이터가 없습니다.",
  "treatment.weekly.noData": "데이터 없음",
  "treatment.weekly.week": "{week}주차",
  "treatment.weekly.compliance": "순응도: {rate}%",
  "treatment.activityPerformanceAria": "{activityName} 수행률 {rate}",
  "treatment.dayLabel": "{date} ({day}일차)",
  "treatment.progressSuffix": " · 진행률 {rate}%",
  "treatment.summary": "치료 요약",
  "treatment.nameWithType": "치료 {type}",
  "treatment.name": "치료",
  "treatment.create.title": "치료 추가하기",
  "treatment.create.subtitle": "환자에게 새로운 치료를 추가합니다. 필요한 정보를 입력하고 저장하기 버튼을 누르세요.",
  "treatment.create.startDate": "시작 날짜",
  "treatment.create.endDate": "종료 날짜",
  "treatment.create.type": "치료 유형",
  "treatment.create.submitting": "치료 추가 중...",
  "treatment.create.days": "{days}일",
  "treatment.toast.stopped": "치료를 중지했습니다.",
  "treatment.toast.added": "치료를 추가했습니다.",
  "treatment.toast.uuidMissing": "치료 UUID가 없어 치료를 중지할 수 없습니다.",

  // 활동
  // 활동 이름/유형은 환자 앱(sat_014_app_rn: src/i18n/locales/<lang>/record.ts, common.ts)의 표기를 기준으로 한다.
  "activity.type.internal": "내적활동",
  "activity.type.external": "외적활동",
  "activity.type.practice": "연습활동",
  "activity.name.cloud": "맑은 하늘 만들기",
  "activity.name.ground": "땅다지기",
  "activity.name.energy": "활기 더하기",
  "activity.name.eye": "시선활동",
  "activity.name.walk": "산책하기",
  "activity.name.nature": "자연감상",
  "activity.name.breath": "숨 고르기",
  "activity.name.deepBreath": "심호흡",
  "activity.detail.title": "심박수 그래프 및 활동 데이터",
  "activity.detail.notFound": "활동 상세 정보를 찾을 수 없습니다.",
  "activity.detail.summary": "활동 요약",
  "activity.detail.heartRateChart": "심박수 그래프",
  "activity.detail.heartRateDescription":
    "심박수 그래프는 시간에 따른 심장 박동을 나타냅니다. 120bpm 기준은 빨간 선으로 표시되며, 심박수가 120bpm을 초과하거나 같은 활동 시간에 여러 심박수가 수집된 구간은 회색 세로 구간으로 표시됩니다.",
  "activity.detail.heartRateEmpty": "심박수 데이터가 없습니다",
  "activity.detail.heartRateValueAria": "심박수 {bpm}bpm",
  "activity.detail.perActivityEmpty": "활동별 상세 데이터가 없습니다",
  "activity.detail.groundData": "땅다지기 데이터",
  "activity.detail.energyData": "활기 더하기 데이터",
  "activity.detail.thoughtTitle": "고민사고 & 수정사고",
  "activity.detail.thoughtAdded": "생각 추가 내역",
  "activity.detail.thoughtRevised": "수정사고 내역",
  "activity.detail.performedActivity": "수행한 활동",
  "activity.detail.rating": "별점",
  "activity.detail.eyeData": "시선활동 데이터",
  "activity.detail.eyeChart": "시선활동 그래프",
  "activity.detail.deepBreathPeriod": "심호흡 {period}",
  "activity.detail.averageHeartRate": "평균 심박수",
  "activity.detail.minHeartRate": "최저 심박수",
  "activity.detail.maxHeartRate": "최고 심박수",
  "activity.detail.discomfortBefore": "활동 전 불편감",
  "activity.detail.discomfortAfter": "활동 후 불편감",
  "activity.detail.walkStep": "걸음 수",
  "activity.detail.feedback": "활동 피드백",
  "activity.detail.feedbackInput": "피드백 입력",
  "activity.detail.feedbackPlaceholder": "피드백을 입력하세요...",
  "activity.detail.feedbackAddPrompt": "여기를 클릭하여 피드백을 추가해주세요.",
  "activity.detail.feedbackAdd": "피드백 추가",
  "activity.eyeDirection.horizontal": "좌우 방향",
  "activity.eyeDirection.pendulum": "진자 운동 방향",
  "activity.eyeDirection.vertical": "상하 방향",
  "activity.eyeDirection.default": "시선활동",

  // 알림 전송
  "notification.statusFilter": "치료 상태 필터",
  "notification.selectAll": "전체 선택",
  "notification.deselectAll": "전체 선택 해제",
  "notification.recipientList": "수신자 목록",
  "notification.noRecipient": "선택된 수신자가 없습니다",
  "notification.addRecipient": "수신자 추가하기",
  "notification.subject": "제목",
  "notification.subjectPlaceholder": "제목을 입력하세요...",
  "notification.body": "메시지 본문",
  "notification.bodyPlaceholder": "메시지를 입력하세요...",
  "notification.selectPatientTitle": "환자 선택",
  "notification.sendTitle": "알림 전송",
  "notification.sendConfirm": "선택한 환자에게 알림을 전송하시겠습니까?",
  "notification.toast.sent": "알림 전송 완료",
  "notification.encouragement.title": "독려 알림 보내기",
  "notification.encouragement.subjectPlaceholder": "제목",
  "notification.encouragement.bodyPlaceholder": "메시지 본문",

  // 운영 로그
  "log.column.date": "날짜",
  "log.column.userType": "사용자 유형",
  "log.column.logType": "로그 유형",
  "log.column.content": "내용",
  "log.empty": "로그가 없습니다.",
  "log.pagination": "운영로그 페이지네이션",

  // 전화번호
  "phone.country.us": "미국",
  "phone.country.kr": "대한민국",
  "phone.validation.required": "전화번호를 입력해야합니다.",
  "phone.validation.format": "전화번호 형식이 아닙니다.(ex: {example})",
} as const;

export type TranslationKey = keyof typeof koMessages;

export type MessageCatalog = Record<TranslationKey, string>;
